import React, { FC, useState } from 'react';
import { IReviewNew, IReviewNewProps } from '../../../shared/interfaces/IReviewNew';
import { Box, Button, Divider, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ReviewHeader from '../ReviewHeader';
import { ExpandLess, MoreVert, Person } from '@mui/icons-material';
import ReviewContent from '../ReviewContent';
import ReviewWrapper from '../ReviewWrapper';
import Block from '../../Block/Block';
import ReviewText from '../ReviewText';

interface Props extends IReviewNewProps {}

const ShopauskunftReview: FC<Props> = ({
  commentingModule,
  hideHeader,
  hideFooter,
  statusModule,
  status,
  deletionModule,
  reviewEntry,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [showAllBlocks, setShowAllBlocks] = useState(false);

  // shopauskunft has no per-review URL: the scraped link answers 410 Gone, so no link button
  const { username, text, rating, blocks } = reviewEntry.review;

  return (
    <ReviewWrapper
      commentingModule={commentingModule}
      hideHeader={hideHeader}
      hideFooter={true}
      rating={rating}
      statusModule={statusModule}
      status={status}
      deletionModule={deletionModule}
      reviewEntry={reviewEntry}
    >
      {username && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: theme.palette.text.secondary,
          }}
        >
          <Person fontSize="small" />
          <Typography
            variant="body1"
            sx={{ ml: theme.spacing(1) }}
          >
            {username}
          </Typography>
        </Box>
      )}
      <ReviewText text={text} />
      {blocks && blocks.length > 0 && (
        <Box sx={{ mt: theme.spacing(3) }}>
          {showAllBlocks ? (
            blocks
              .filter((value) => typeof value.rating === 'number')
              .map(({ rating, text, title }, index) => {
                return (
                  <Box
                    key={index}
                    sx={{ mt: theme.spacing(1) }}
                  >
                    <Divider orientation="horizontal" />
                    <Block
                      title={title}
                      text={text}
                      rating={rating}
                    />
                  </Box>
                );
              })
          ) : (
            <Box sx={{ mt: theme.spacing(1) }}>
              <Divider orientation="horizontal" />
              <Block
                title={blocks[0].title}
                text={blocks[0].text}
                rating={blocks[0].rating}
              />
            </Box>
          )}
          <Button
            variant="outlined"
            size="small"
            startIcon={showAllBlocks ? <ExpandLess /> : <MoreVert />}
            onClick={() => setShowAllBlocks(!showAllBlocks)}
            sx={{
              mb: theme.spacing(1),
            }}
          >
            {showAllBlocks ? t('show_less') : t('show_more')}
          </Button>
        </Box>
      )}
    </ReviewWrapper>
  );
};

export default ShopauskunftReview;
